export default __webpack_public_path__ + "static/media/check-ai.65ae44ae.png";